import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { Link } from 'react-router-dom';
import {
  ErrorMessage,
  Utils,
  C,
  selectServicesKapp,
} from '@kineticdata/bundle-common';
import { logout, I18n, Moment } from '@kineticdata/react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { actions } from '../redux/modules/app';
import { actions as staffActions } from '../redux/modules/staff';
import { PageTitle } from './shared/PageTitle';
import { Record } from 'immutable';
import uuid from 'uuid';
import classNames from 'classnames';

const getCurrentDateTimeLocalValue = () => {
  const date = new Date();
  return `${date.toISOString().substring(0, 11)}${date
    .toTimeString()
    .substring(0, 5)}`;
};

export const EditProfileComponent = ({
  profile,
  profileUpdating,
  dirty,
  fieldValues,
  handleFieldChange,
  staff,
  staffError,
  alternate,
  handleAlternateToggle,
  handleAlternateChange,
  handleAlternateAdd,
  handleAlternateRemove,
  handleSubmit,
  handleReset,
  locales,
  timezones,
  servicesKapp,
  fetchProfileRequest,
}) => (
  <div className="page-container">
    <div className="page-panel">
      <PageTitle
        parts={['Profile']}
        title={'Profile'}
        actions={[
          {
            icon: 'sync',
            onClick: () => fetchProfileRequest(),
            aria: 'Reload Profile',
          },
        ]}
      />
      {profile ? (
        <>
          <form onSubmit={handleSubmit} className="form-unstyled">
            <div className="form-group__columns">
              <div className="form-group">
                <label htmlFor="displayName">
                  <I18n>Display Name</I18n>
                </label>
                <input
                  type="text"
                  id="displayName"
                  name="displayName"
                  value={fieldValues.displayName}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label htmlFor="displayName">
                  <I18n>eAuth Id</I18n>
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={fieldValues.username}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">
                  <I18n>Email</I18n>
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={fieldValues.email}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">
                  <I18n>Company</I18n>
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={fieldValues.company}
                  disabled={true}
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">
                  <I18n>eAuth Assurance Level</I18n>
                </label>
                <input
                  type="text"
                  id="eAuthAssuranceLevel"
                  name="eAuthAssuranceLevel"
                  value={fieldValues.eauthAssuranceLevel}
                  disabled={true}
                />
              </div>
            </div>
            <div className="mb-3 mt-n2">
              <small>
                <I18n>
                  Display Name, Email, and Company are populated from the
                  e-Authentication System.
                </I18n>
              </small>
            </div>

            <div className="form-group__columns">
              <div className="form-group">
                <label htmlFor="preferredLocale">Preferred Locale</label>
                <select
                  type="text"
                  id="preferredLocale"
                  name="preferredLocale"
                  className="form-control"
                  onChange={handleFieldChange}
                  value={fieldValues.preferredLocale}
                >
                  <option value="">None Selected</option>
                  {locales.map(locale => (
                    <option
                      value={locale.code}
                      key={`${locale.code}+${locale.name}`}
                    >
                      {locale.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="timezone">Timezone</label>
                <select
                  type="text"
                  id="timezone"
                  name="timezone"
                  className="form-control"
                  onChange={handleFieldChange}
                  value={fieldValues.timezone}
                >
                  <option value="">None Selected</option>
                  {timezones.map(timezone => (
                    <option value={timezone.id} key={timezone.id}>
                      {timezone.name} ({timezone.id})
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="agreements">
                <I18n>Portal Roles</I18n>
              </label>
              <div
                className="form-control h-auto"
                id="agreements"
                name="agreements"
                readOnly
              >
                {fieldValues.agreements
                  .sort()
                  .join(', ')
                  .toUpperCase() || <em className="text-muted">None</em>}
              </div>
              {servicesKapp && (
                <small>
                  To request additional roles go to the{' '}
                  <Link
                    to={`/kapps/${servicesKapp.slug}/forms/${
                      C.FORM_SLUG_PORTAL_ROLE_REQUEST
                    }`}
                  >
                    Portal Role Request Form
                  </Link>
                </small>
              )}
              <small className="d-block">
                Note: If you are looking for newly added portal roles to appear
                you must{' '}
                <button
                  className="btn btn-text"
                  onClick={() =>
                    logout(() => {
                      window.location.href =
                        'https://www.eauth.usda.gov/eauth/b/usda/logoff';
                    })
                  }
                >
                  log out of eAuth
                </button>{' '}
                and log back into ERMS.
              </small>
            </div>

            <div className="form-group">
              <label htmlFor="agencies">
                <I18n>eAuth Agencies</I18n>
              </label>
              <div
                className="form-control h-auto"
                id="agencies"
                name="agencies"
                readOnly
              >
                {fieldValues.agencies
                  .sort()
                  .join(', ')
                  .toUpperCase() || <em className="text-muted">None</em>}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="newFormNotification">
                <I18n>Notify Me When New Forms Are Created</I18n>
              </label>
              <select
                id="newFormNotification"
                name="newFormNotification"
                onChange={handleFieldChange}
                value={fieldValues.newFormNotification}
              >
                <option value="">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="alternates" className="d-flex align-items-end">
                <I18n>Alternate Approvers</I18n>
                <button
                  type="button"
                  className="btn btn-outline-dark btn-sm ml-auto"
                  onClick={handleAlternateToggle(true)}
                >
                  <I18n>Add New</I18n>
                </button>
              </label>
              <div className="scroll-wrapper-h">
                <table id="alternates" className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th style={{ width: '1%' }} className="text-nowrap">
                        In Flight
                      </th>
                      <th style={{ width: '1%' }} />
                    </tr>
                  </thead>
                  <tbody>
                    {fieldValues.alternates.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-muted text-center">
                          You have no alternate approvers.
                        </td>
                      </tr>
                    )}
                    {fieldValues.alternates.map(a => (
                      <tr key={a.guid}>
                        <td>
                          {a['Display Name']} - {a['Email']}
                        </td>
                        <td>
                          <Moment
                            timestamp={new Date(a['Start Date'])}
                            format={Moment.formats.dateTimeNumeric}
                          />
                        </td>
                        <td>
                          <Moment
                            timestamp={new Date(a['End Date'])}
                            format={Moment.formats.dateTimeNumeric}
                          />
                        </td>
                        <td>
                          <I18n>{a['In Flight'] ? 'Yes' : 'No'}</I18n>
                        </td>
                        <td className="text-right">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={handleAlternateRemove(a.guid)}
                          >
                            <span className="fa fa-fw fa-trash" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <Modal
                  isOpen={alternate.open}
                  toggle={handleAlternateToggle(false)}
                >
                  <div className="modal-header">
                    <h4 className="modal-title">
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={handleAlternateToggle(false)}
                      >
                        <I18n>Close</I18n>
                      </button>
                      <span>
                        <I18n>Add Alternate Approver</I18n>
                      </span>
                    </h4>
                  </div>
                  <ModalBody className="form">
                    <div className="form-group required">
                      <label className="field-label" htmlFor="alternate-user">
                        <I18n>User</I18n>
                      </label>
                      <I18n
                        render={translate => {
                          const staffList = Array.isArray(staff)
                            ? staff
                                .filter(
                                  user =>
                                    user.username !== profile.username &&
                                    !fieldValues.alternates.find(
                                      a => a['Username'] === user.username,
                                    ),
                                )
                                .map(user => {
                                  const displayName = user.displayName
                                    ? user.displayName.toUpperCase()
                                    : user.displayName || '';
                                  return {
                                    ...user,
                                    displayName,
                                    sortName: displayName.split(/\s/i).pop(),
                                  };
                                })
                                .sort(
                                  (a, b) =>
                                    a.sortName > b.sortName
                                      ? 1
                                      : b.sortName > a.sortName
                                        ? -1
                                        : 0,
                                )
                            : staff;
                          return (
                            <select
                              id="alternate-user"
                              name="alternate-user"
                              value={alternate['Username']}
                              className={classNames({
                                'border-danger': !alternate['Username'],
                              })}
                              onChange={e => {
                                var user = staff.find(
                                  user => user.username === e.target.value,
                                );
                                handleAlternateChange({
                                  Username: user ? user.username : '',
                                  Email: user ? user.email : '',
                                  'Display Name': user ? user.displayName : '',
                                });
                              }}
                            >
                              <option
                                value=""
                                disabled={!!staffError || !Array.isArray(staff)}
                              >
                                {!!staffError
                                  ? translate('Error loading users')
                                  : !Array.isArray(staffList)
                                    ? translate('Loading users...')
                                    : staffList.length === 0
                                      ? translate('No available users found')
                                      : ''}
                              </option>
                              {Array.isArray(staff)
                                ? staffList.map(user => (
                                    <option
                                      value={user.username}
                                      key={user.username}
                                    >{`${user.displayName} - ${
                                      user.email
                                    }`}</option>
                                  ))
                                : null}
                            </select>
                          );
                        }}
                      />
                    </div>
                    <div className="form-group required">
                      <label className="field-label" htmlFor="alternate-start">
                        <I18n>Start Date</I18n>
                      </label>
                      <input
                        id="alternate-start"
                        name="alternate-start"
                        type="datetime-local"
                        className={classNames({
                          'border-danger': !alternate.startValid,
                        })}
                        value={alternate['Start Date']}
                        onChange={e => {
                          handleAlternateChange({
                            'Start Date': e.target.value || '',
                            startValid:
                              e.target.value && e.target.checkValidity(),
                          });
                        }}
                        min={getCurrentDateTimeLocalValue()}
                        max={alternate['End Date']}
                      />
                    </div>
                    <div className="form-group required">
                      <label className="field-label" htmlFor="alternate-end">
                        <I18n>End Date</I18n>
                      </label>
                      <input
                        id="alternate-end"
                        name="alternate-end"
                        type="datetime-local"
                        className={classNames({
                          'border-danger': !alternate.endValid,
                        })}
                        value={alternate['End Date']}
                        onChange={e => {
                          handleAlternateChange({
                            'End Date': e.target.value || '',
                            endValid:
                              e.target.value && e.target.checkValidity(),
                          });
                        }}
                        min={alternate['Start Date']}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="alternate-in-flight"
                        className="d-flex align-items-center"
                      >
                        <I18n>In Flight</I18n>
                        <input
                          id="alternate-in-flight"
                          name="alternate-in-flight"
                          type="checkbox"
                          className="ml-2"
                          checked={alternate['In Flight']}
                          onChange={e =>
                            handleAlternateChange({
                              'In Flight': !!e.target.checked,
                            })
                          }
                        />
                      </label>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={
                        !alternate['Username'] ||
                        !alternate.startValid ||
                        !alternate.endValid
                      }
                      onClick={handleAlternateAdd}
                    >
                      Add
                    </button>
                  </ModalFooter>
                </Modal>
              </div>
            </div>

            <div className="text-right">
              <button
                type="submit"
                disabled={!dirty || profileUpdating}
                className="btn btn-primary"
              >
                {profileUpdating ? (
                  <>
                    <span className="fa fa-spinner fa-spin fa-fw" />{' '}
                    <I18n>Saving</I18n>
                  </>
                ) : (
                  <I18n>Save Changes</I18n>
                )}
              </button>
              <button
                type="button"
                disabled={!dirty || profileUpdating}
                className="btn btn-link-danger"
                onClick={handleReset}
              >
                <I18n>Reset</I18n>
              </button>
            </div>
          </form>
        </>
      ) : (
        <ErrorMessage title="Profile not found" />
      )}
    </div>
  </div>
);

const translateProfileToFieldValues = profile => ({
  username: profile.username || '',
  displayName: profile.displayName || '',
  email: profile.email || '',
  preferredLocale: profile.preferredLocale || '',
  timezone: profile.timezone || '',
  company: Utils.getAttributeValue(profile, C.ATTRIBUTE_USER_COMPANY, ''),
  agreements: profile.agreements,
  agencies: profile.agencies,
  eauthAssuranceLevel: Utils.getAttributeValue(
    profile,
    C.ATTRIBUTE_USER_EAUTH_ASSURANCE_LEVEL,
    '',
  ),
  newFormNotification: Utils.getProfileAttributeValue(
    profile,
    C.ATTRIBUTE_USER_PROFILE_NEW_FORM_NOTIFICATION,
    '',
  ),
  alternates: Utils.getProfileAttributeValues(
    profile,
    C.ATTRIBUTE_USER_PROFILE_ALTERNATES,
    [],
  )
    .map(a => {
      try {
        const alternate = JSON.parse(a);
        return typeof alternate === 'object' ? alternate : null;
      } catch (e) {
        return null;
      }
    })
    .filter(Boolean),
});

const translateFieldValuesToProfile = (fieldValues, profile) => ({
  preferredLocale: fieldValues.preferredLocale,
  timezone: fieldValues.timezone,
  profileAttributesMap: {
    [C.ATTRIBUTE_USER_PROFILE_NEW_FORM_NOTIFICATION]: [
      fieldValues.newFormNotification,
    ].filter(Boolean),
    [C.ATTRIBUTE_USER_PROFILE_ALTERNATES]: fieldValues.alternates
      .filter(Boolean)
      .map(a => {
        const { open, startValid, endValid, ...alternate } = a;
        return JSON.stringify(alternate);
      }),
  },
});

const mapStateToProps = state => ({
  locales: state.app.locales,
  timezones: state.app.timezones,
  profile: state.app.profile,
  updating: state.app.profileUpdating,
  staff: state.staff.data,
  staffError: state.staff.error,
  servicesKapp: selectServicesKapp(state),
});

const mapDispatchToProps = {
  fetchProfileRequest: actions.fetchProfileRequest,
  updateProfileRequest: actions.updateProfileRequest,
  fetchStaffRequest: staffActions.fetchStaffRequest,
};

const AlternateApprover = Record({
  open: false,
  'Display Name': '',
  Username: '',
  Email: '',
  'Start Date': '',
  startValid: false,
  'End Date': '',
  endValid: false,
  'In Flight': false,
  guid: null,
});

export const EditProfile = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('dirty', 'setDirty', false),
  withState('alternate', 'setAlternate', AlternateApprover({ guid: uuid() })),
  withState('fieldValues', 'setFieldValues', props =>
    translateProfileToFieldValues(props.profile || {}),
  ),
  withHandlers({
    handleFieldChange: props => ({ target: { name, value } }) => {
      if (name) {
        props.setFieldValues({ ...props.fieldValues, [name]: value });
        props.setDirty(true);
      }
    },
    handleAlternateToggle: props => open => () => {
      props.setAlternate(
        !open
          ? AlternateApprover({ guid: uuid() })
          : props.alternate.set('open', true),
      );
    },
    handleAlternateChange: props => data =>
      data &&
      props.setAlternate(
        AlternateApprover({ ...props.alternate.toJS(), ...data }),
      ),
    handleAlternateAdd: props => () => {
      props.setFieldValues({
        ...props.fieldValues,
        alternates: [...props.fieldValues.alternates, props.alternate.toJS()],
      });
      props.setAlternate(AlternateApprover({ guid: uuid() }));
      props.setDirty(true);
    },
    handleAlternateRemove: props => guid => () => {
      props.setFieldValues({
        ...props.fieldValues,
        alternates: props.fieldValues.alternates.filter(a => a.guid !== guid),
      });
      props.setDirty(true);
    },
    handleSubmit: props => event => {
      event.preventDefault();
      props.updateProfileRequest(
        translateFieldValuesToProfile(props.fieldValues, props.profile),
      );
      props.setDirty(false);
    },
    handleReset: props => () => {
      props.setFieldValues(translateProfileToFieldValues(props.profile || {}));
      props.setDirty(false);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchProfileRequest();
      if (!this.props.staff) {
        this.props.fetchStaffRequest();
      }
    },
    componentDidUpdate(prevProps) {
      if (
        this.props.profile &&
        (!prevProps.profile ||
          this.props.profile.updatedAt !== prevProps.profile.updatedAt)
      ) {
        this.props.setFieldValues({
          ...prevProps.fieldValues,
          ...translateProfileToFieldValues(this.props.profile),
        });
      }
    },
  }),
)(EditProfileComponent);
